<template>
  <div :class="['loadingModal-circular', { 'is-turning': turning }]"></div>
</template>

<script>
export default {
  name: 'TkCircularProgress',
  props: {
    turning: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkCircularProgress.scss';
</style>
